export const TOO_MANY_PRODUCTS_MESSAGE = `We're sorry, you've exceeded the maximum number of items (89) 
allowed in a quote. Select fewer items and try again.`;
export const QUANTITY_LIMIT = 9999;

// Progress Bar Drawer Constants
export const PRODUCTS_LOADING_MESSAGE = `We are fetching important information for the items you have 
selected. You will be redirected momentarily...`;